/**
 * Runtime value for the Cosmwasm Platform
 */
export const _platform = "Cosmwasm";
//# sourceMappingURL=types.js.map